import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  computed
} from '@angular/core';
import { OverlayPanel, PopoverStyle } from 'primeng/overlaypanel';

export type PopupAlignment = 'default' | 'center';

@Component({
  selector: 'portal-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
  providers: [PopoverStyle],
  standalone: false
})
export class ConfirmationPopupComponent extends OverlayPanel {
  @ViewChild('confirmationPanel') private confirmationPanel!: OverlayPanel;

  @Input() acceptLabel = 'Yes';
  @Input() rejectLabel = 'No';
  @Input() isAcceptDisabled = false;
  @Input() alignment: PopupAlignment = 'default';

  @Output() accept = new EventEmitter<void>();
  @Output() reject = new EventEmitter<void>();

  /**
   * Compute the styleClass based on alignment
   * Using computed signal for better performance
   */
  computedStyleClass = computed(() => {
    const classes: string[] = [];

    if (this.styleClass) {
      classes.push(this.styleClass);
    }

    if (this.alignment === 'center') {
      classes.push('position-center');
    }

    return classes.join(' ');
  });

  show(event: MouseEvent, target?: EventTarget): void {
    const eventTarget = target || event.target;
    this.confirmationPanel.show(event, eventTarget);
  }

  hide() {
    this.confirmationPanel.hide();
  }
}
